import { useRouterState } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { useMemo } from "react"

export function useBreadcrumbs() {
  const { matches } = useRouterState()

  return useMemo(() => {
    const breadcrumbs = matches
      .filter((match) => match.loaderData && match.loaderData instanceof Crumb)
      .map((match) => match.loaderData as Crumb)

    breadcrumbs.forEach((crumb, index) => {
      if (crumb.isReplace()) {
        breadcrumbs.splice(index - 1, 1)
      }
    })

    const currentCrumb = breadcrumbs.length > 0 ? breadcrumbs.at(-1) : undefined
    const previousCrumbs = breadcrumbs.slice(0, -1)
    const previousCrumb = previousCrumbs.at(-1)

    const showDropdown = previousCrumbs.length > 3
    const middleCrumbs = showDropdown ? previousCrumbs.slice(1, -1) : []
    const visibleCrumbs = showDropdown
      ? [previousCrumbs[0], previousCrumbs[previousCrumbs.length - 1]].filter(Boolean)
      : previousCrumbs

    return {
      currentCrumb,
      middleCrumbs,
      visibleCrumbs,
      previousCrumbs,
      previousCrumb,
      showDropdown,
    }
  }, [matches])
}
